module.exports = __webpack_public_path__ + "img/icons8-one-page-14.225d8ede.svg";